import { AGGREGATION_OPTIONS } from '../constants';
import { getGroupByBehaviour, GroupByBehaviour } from './behaviour';

export type StatTransformStrategy = {
    applyAverage(originalValue: number, uniqueAthleteCount: number, groupByOption: string): number;
    applyNormalisation(originalValue: number, multiplier: number, groupByOption: string): number;
};

export const getStatsTransformStrategy = (aggregation: string) => {
    return strategyMap[aggregation] || defaultStrategy;
};

const defaultStrategy: StatTransformStrategy = {
    applyAverage: (value) => value,
    applyNormalisation: (value) => value,
};

// Looks up and returns the desired functionality for the given aggregation and groupBy option
export const strategyMap: Record<string, StatTransformStrategy> = {
    [AGGREGATION_OPTIONS.average]: {
        applyAverage: (value, athleteCount, groupByOption) => {
            const behaviour: GroupByBehaviour = getGroupByBehaviour(groupByOption);
            return behaviour.averaging(value, athleteCount);
        },
        applyNormalisation: (value, multiplier, groupByOption) => {
            const behaviour: GroupByBehaviour = getGroupByBehaviour(groupByOption);
            return behaviour.normalisation(value, multiplier);
        },
    },
    [AGGREGATION_OPTIONS.count]: {
        applyAverage: (value, athleteCount, groupByOption) => {
            const behaviour: GroupByBehaviour = getGroupByBehaviour(groupByOption);
            return behaviour.averaging(value, athleteCount);
        },
        applyNormalisation: (value, multiplier, groupByOption) => {
            const behaviour: GroupByBehaviour = getGroupByBehaviour(groupByOption);
            return behaviour.normalisation(value, multiplier);
        },
    },
    [AGGREGATION_OPTIONS.sum]: {
        applyAverage: (value, athleteCount) => value / (athleteCount || 1),
        applyNormalisation: (value) => value,
    },

    // Extend here if new aggregations are needed
};
